import { render, staticRenderFns } from "./SendResetPassword.vue?vue&type=template&id=283a33fa&scoped=true&"
import script from "./SendResetPassword.vue?vue&type=script&lang=js&"
export * from "./SendResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283a33fa",
  null
  
)

export default component.exports